const env = {
    // BACKEND_BASE_URL: 'http://localhost:7573'
    BACKEND_BASE_URL: 'https://bishamon.codeguidesserver.de'
  }
  
  export default env
  